import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import PageLayout from '../../components/PageLayout'

export default function CancelSubscriptionInfoPage() {
  const { t } = useTranslation()
  const supportEmail = import.meta.env.VITE_SUPPORT_EMAIL as string

  return (
    <PageLayout withLogin>
      <div className="flex grow flex-col items-center justify-center space-y-10 text-center">
        <h1 className="text-3xl font-bold" data-testid="label-header">
          {t('pages.helpCenter.cancelInfo.heading', {
            defaultValue: 'How to Cancel Your Subscription',
          })}
        </h1>

        <div className="w-full max-w-lg space-y-6 text-left">
          <div className="rounded-2xl border border-[#e5e7eb] bg-white p-6">
            <h2 className="text-lg font-bold">
              {t('pages.helpCenter.cancelInfo.helpCenterTitle', {
                defaultValue: '1. From the Help Center',
              })}
            </h2>
            <p className="mt-2 text-[#4a5568]">
              {t('pages.helpCenter.cancelInfo.helpCenterDescription', {
                defaultValue:
                  'Visit the Help Center and follow the steps to manage or cancel your subscription.',
              })}
            </p>
            <Link
              to="/help-center/cancelation"
              className="text-primary mt-3 inline-block font-semibold hover:opacity-80"
            >
              {t('pages.helpCenter.cancelInfo.goToHelpCenter', {
                defaultValue: 'Go to Help Center →',
              })}
            </Link>
          </div>

          <div className="rounded-2xl border border-[#e5e7eb] bg-white p-6">
            <h2 className="text-lg font-bold">
              {t('pages.helpCenter.cancelInfo.appTitle', {
                defaultValue: '2. From the App',
              })}
            </h2>
            <p className="mt-2 text-[#4a5568]">
              {t('pages.helpCenter.cancelInfo.appDescription', {
                defaultValue:
                  'Open the app, go to Settings, then tap Subscription. From there you can manage or cancel your plan directly.',
              })}
            </p>
          </div>

          <div className="rounded-2xl border border-[#e5e7eb] bg-white p-6">
            <h2 className="text-lg font-bold">
              {t('pages.helpCenter.cancelInfo.supportTitle', {
                defaultValue: '3. Contact Customer Support',
              })}
            </h2>
            <p className="mt-2 text-[#4a5568]">
              {t('pages.helpCenter.cancelInfo.supportDescription', {
                defaultValue:
                  "Reach out to our support team and we'll help you cancel your subscription.",
              })}
            </p>
            <Link
              to={`mailto:${supportEmail}`}
              className="text-primary mt-3 inline-block font-semibold hover:opacity-80"
            >
              {supportEmail}
            </Link>
          </div>
        </div>

        <p className="max-w-md text-sm text-[#94a3b8]">
          {t('pages.helpCenter.cancelInfo.note', {
            defaultValue:
              "After cancellation, you'll retain access to your subscription features until the end of your current billing period. No further charges will apply.",
          })}
        </p>
      </div>
    </PageLayout>
  )
}
